import React from 'react'
import KinkForm from './KinkForm'

function Page() {
    return (
        <div className="page">
            <h1>My Kinks</h1>
            <KinkForm />            
        </div>
    )
}

export default Page
